module.exports = __webpack_public_path__ + "public/dist/banner_close.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner_close.png
// module id = 145
// module chunks = 214